// src/api/base.js
import axios from 'axios'
import store from '@/store'

console.log("=== base.js 配置检查 ===");
console.log("process.env.VUE_APP_BASE_WSAPI:", process.env.VUE_APP_BASE_WSAPI);
console.log("环境:", process.env.NODE_ENV);

const isDevelopment = process.env.NODE_ENV === 'development'

// ========== 路径配置 ==========
// 方案B：开发环境用dev-api，生产环境用prod-api
/**
 * 前端请求: /dev-api/auth/login
     ↓
Vue代理转发(vue.config.js): http://localhost:8081/dev-api/auth/login
     ↓
后端处理并返回
 */

export const API_BASE_URL = isDevelopment 
  ? ''  // 开发环境：本地代理
  : ''  // 生产环境：相对路径

// 关键配置：区分环境的路径前缀
export const API_PREFIX = isDevelopment 
  ? '/dev-api'  // 开发环境
  : '/prod-api'  // 生产环境

export const AUTH_PATH = '/auth'
export const USER_PATH = ''  // core-api直接挂在dev-api或prod-api下
export const AI_PATH = ''    // ai-core-api也直接挂载

// 完整URL
export const AUTH_URL = isDevelopment 
  ? '/auth'  // 这里应该是 '/auth'，不是完整URL
  : (process.env.VUE_APP_SSO_AUTH_URL || '/api/auth')

console.log('=== AUTH_URL ===', AUTH_URL)

export const USER_URL = API_BASE_URL + API_PREFIX
export const AI_URL = API_BASE_URL + API_PREFIX
export const WS_URL = isDevelopment
  ? 'ws://localhost:8181/ws'
  : 'wss://www.bj-sunrise.net/ws'

export const LOCAL_WSPI_URL = process.env.VUE_APP_BASE_WSAPI
console.log("🌐 WebSocket URL 配置:", LOCAL_WSPI_URL);
console.log("🌐 API_BASE_URL:", API_BASE_URL);
console.log("🌐API_PREFIX:", API_PREFIX);
console.log("🌐 AI_URL:", AI_URL);
console.log("🌐 AUTH_URL:", AUTH_URL);

// ========== 创建axios实例 ==========

// 认证专用实例
export const authHttp = axios.create({
  baseURL: AUTH_URL,
  timeout: 30000
})

// 用户和AI共用实例（根据URL区分）
export const http = axios.create({
  baseURL: AI_URL,
  timeout: 30000
})

// ========== 请求拦截器 ==========

// 认证实例拦截器
authHttp.interceptors.request.use(config => {
  const token = store.state.auth?.token
 // 判断是否需要加token（排除认证相关接口）
  const isAuthRequest = config.url?.includes('/auth/')
  const excludedUrls = ['/auth/login', '/auth/register', '/auth/captcha']
  
    if (token && !isAuthRequest && !excludedUrls.some(url => config.url?.includes(url))) {
    config.headers.Authorization = `Bearer ${token}`
  }
  
  if (isDevelopment) {
    console.log('[AUTH请求]', config.method?.toUpperCase(), config.url)
    console.log('完整URL:', config.baseURL + config.url)
  }
  
  return config
})

// 主实例拦截器
http.interceptors.request.use(config => {
    // 从 localStorage 直接读取
    const storedToken = localStorage.getItem('auth_token')
    const storedUser = JSON.parse(localStorage.getItem('auth_user') || '{}')
    
    if (storedToken) {
        config.headers.Authorization = `Bearer ${storedToken}`
    }
    if (storedUser.username) {
        config.headers['X-Username'] = storedUser.username
    }
    
    // tenantId 同理
// base.js 第103-106行替换为此处代码
let storedTenant = {};
try {
    const tenantStr = localStorage.getItem('auth_tenant');
    // 过滤掉 'null'、'undefined' 等无效字符串，默认给 '{}'
    storedTenant = tenantStr && tenantStr !== 'null' && tenantStr !== 'undefined' 
        ? JSON.parse(tenantStr) 
        : {};
} catch (e) {
    storedTenant = {};
}

if (storedTenant && storedTenant.tenantId) {
    config.headers['X-Tenant-Id'] = String(storedTenant.tenantId);
}

    // 🔴 所有请求都会经过这里，打印出来
    console.log('🔍 [拦截器] 所有请求:', config.method, config.url);
    const token = store.state.auth?.token;
    
    // 2️⃣ 定义公开接口（不需要 token 的接口）
    const publicEndpoints = [
        '/auth/login',
        '/auth/register', 
        '/auth/captcha',
        '/auth/login_sms',
        '/sms/send-code',
        '/user/set_pwd_sms',
        '/user/change_pwd',
        '/tenant/change_admin',
        '/employees/change_phone'
    ];
    
    // 3️⃣ 判断当前请求是否属于公开接口
    const isPublicEndpoint = publicEndpoints.some(endpoint => 
        config.url?.includes(endpoint)
    );
    
    // 4️⃣ 只有在 非公开接口 且 有 token 时，才加上 Authorization 头
    if (token && !isPublicEndpoint) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    
    // 5️⃣ ✅ 修复：安全地获取 tenantId 和 username
    try {
        const stateAuth = store.state.auth;
        if (stateAuth) {
            const tenantId = stateAuth.tenantInfo?.tenantId;
            if (tenantId) {
                config.headers['X-Tenant-Id'] = String(tenantId);
            }
            const username = stateAuth.userInfo?.username;
            if (username) {
                config.headers['X-Username'] = username;
            }
        }
    } catch (e) {
        console.warn('⚠️ 获取 auth 状态失败:', e);
    }
    
    return config;
});

// ========== 响应拦截器 ==========
const setupResponseInterceptor = (instance, name) => {
  instance.interceptors.response.use(
    response => {
      // 根据后端实际返回结构调整
      return response
    },
    error => {
      if (isDevelopment) {
        console.error(`[${name}错误]`, error.response || error)
      }
      
      // 401处理
      if (error.response?.status === 401) {
        // 检查是否是刷新token接口
        const isRefreshRequest = error.config.url?.includes('/auth/refresh')
        if (isRefreshRequest) {
          // 刷新token失败，退出登录
          store.dispatch('auth/logout')
          window.location.href = '/login'
        } else {
          // 其他401，尝试刷新token
          const shouldRefresh = !error.config._retry && 
                               store.state.auth?.refreshToken
          
          if (shouldRefresh) {
            error.config._retry = true
            return store.dispatch('auth/refreshToken').then(() => {
              const newToken = store.state.auth.token
              error.config.headers.Authorization = `Bearer ${newToken}`
              return instance(error.config)
            }).catch(() => {
              store.dispatch('auth/logout')
              window.location.href = '/login'
              return Promise.reject(error)
            })
          }
        }
      }
      
      return Promise.reject(error)
    }
  )
}

setupResponseInterceptor(authHttp, 'AUTH')
setupResponseInterceptor(http, 'API')

// ========== 兼容旧的导出 ==========
export const SSO_AUTH_URL = AUTH_URL
export const SSO_API_URL = USER_URL
export const LOCAL_API_URL = '/dev-api';
export const LOCAL_WSAPI_URL = WS_URL

// ========== 辅助函数 ==========
// 用于构建完整URL
export const buildUrl = (path, service = 'ai') => {
  // service: 'auth' | 'user' | 'ai'
  if (service === 'auth') {
    return API_PREFIX + '/auth' + (path.startsWith('/') ? path : '/' + path)
  }
  return API_PREFIX + (path.startsWith('/') ? path : '/' + path)
}

// 调试输出
console.log('环境:', process.env.NODE_ENV)
console.log('API前缀:', API_PREFIX)
console.log('认证URL:', AUTH_URL)
console.log('用户URL:', USER_URL)
console.log('AI URL:', AI_URL)

export { ssoHttp } from './axios'